
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_2","data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16.89 16.88"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M15.88 0H8.8c-.56 0-.66.24-1.19.8L.64 7.75c-.86.85-.86 2.23 0 3.09l5.42 5.4c.86.85 2.24.85 3.1 0l6.97-6.95c.45-.45.77-.67.77-1.23V1.01C16.9.45 16.45 0 15.89 0zm-.53 8.52l-6.97 6.95c-.43.43-1.12.43-1.55 0l-5.41-5.41a1.08 1.08 0 010-1.54l6.96-6.95c.25-.25.64-.57.92-.57h6.07c.28 0 .51.23.51.5v6.05c0 .28-.26.69-.53.96z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M10.32 3.5c-.86.85-.86 2.23 0 3.09.85.85 2.24.85 3.1 0 .86-.85.85-2.23 0-3.09-.86-.85-2.24-.85-3.1 0zm2.32 2.32c-.43.43-1.12.43-1.55 0a1.08 1.08 0 010-1.54c.43-.43 1.12-.43 1.55 0 .43.43.43 1.12 0 1.54z"}})])])
          )
        }
      }
    